import * as React from "react";

export const PrivacyNL = () => {
  return (
    <div className="pt-4">
      <h2>Uw privacy</h2>
      Het CAK gaat zorgvuldig om met uw persoonlijke gegevens. Wij gebruiken uw gegevens alleen om de aanvraag
      te beoordelen. Lees meer over <a href="https://www.hetcak.nl/uw-privacy">uw privacy</a>.
    </div>
  );
};
